
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.848 3.151L11 1l-.848 2.151L8 4l2.152.849L11 7l.848-2.151L14 4l-2.152-.849zM18 11h3v9h-3v-9zm-2 2h-3v7h3v-7zm-8 2h3v5H8v-5zm-2 2H3v3h3v-3zm17 4H1v2h22v-2zM20 1l.849 2.151L23 4l-2.151.849L20 7l-.849-2.151L17 4l2.151-.849L20 1zm-2.174 6.5L16.678 5.86l-6.585 4.612-.573-.82-1.148-1.638-1.638 1.147L1 13.177l1.147 1.639L7.881 10.8l1.721 2.458.032-.022 1.606-1.125L17.826 7.5z"}})])
          )
        }
      }
    